import React from "react"
import styled from "styled-components"

export default function BlogArrow({ className }) {
  return (
    <Wrapper className={className}>
      <svg
        className="svgRow"
        width="340"
        height="27"
        viewBox="0 0 340 27"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 17H75L67.8205 10"
          stroke="#FFC211"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M135 17H205L197.821 10"
          stroke="white"
          strokeWidth="2"
          strokeinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Wrapper>
  )
}
const Wrapper = styled.div`
  width: 100px;
  overflow: hidden;
  position: relative;
  display: flex;
  .svgRow {
    margin-left: 0px;
    flex: 0 0 360px;
    margin-left: -240px;
    transition: 0.3s;
    position: relative;
    bottom: 0;
  }
  &.hover {
    .svgRow {
      margin-left: 0px;
    }
  }
  @media (max-width: 768px) {
    width: 50px;
    overflow: hidden;
    .svgRow {
      margin-left: -50px !important;
    }
  }
`
